import { Fetch } from 'lib';
import type { TagSummary } from 'types';

type RequestResponses = {
  total: number;
  data: TagSummary[];
};

type RequestParameters = {
  searchKey: string;
  pageSize: number;
  pageNumber: number;
};

const searchTags = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminTag/searchTags',
    params,
  });

export { searchTags };
